import {
  ReactElement,
  HTMLAttributes,
} from "react";
import { Footer, Header, HeaderResponsive, MiniHeader } from "../layout";

import { styled, useTheme, CSSObject } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import { miniMenuStatus } from "../../Redux/services/generalService";
import { useDispatch } from "react-redux";
//
import { connect } from "react-redux";


interface Props extends HTMLAttributes<HTMLElement> {
  children: any;
  title: string;
  miniMenu: boolean;
  noBg?:boolean;
  noPadding?:boolean;

}

const drawerWidth = 254;

const openedMixin = (theme: any): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: any): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop: string) => prop !== 'open' })(
  ({ theme, open }: { theme: any, open: any }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);



export function Layout({ children, title, miniMenu , noBg , noPadding }: Props): ReactElement {
  const theme = useTheme();
  const dispatch = useDispatch();

  const handleDrawerOpen = () => {
    dispatch(miniMenuStatus(!miniMenu))
  };

  const handleDrawerClose = () => {
    dispatch(miniMenuStatus(false))

  }

  return (
    <>
    <div className="layout">
      <div className="hide-mobile">
        <Drawer variant="permanent" open={miniMenu} theme={theme} >
          {miniMenu ?

            <HeaderResponsive handleDrawerClose={handleDrawerClose} />
            :
            <MiniHeader handleDrawerOpen={handleDrawerOpen} />
          }
        </Drawer>
      </div>
      <div className={`${miniMenu ? "calc-w" : "w-100"} ${noBg ? "" : "bg-white"} layout-content `}>
        <Header title={title} />
        <div className={`${noPadding ? "" : "layout-content-padding"} layout-content-height`}>
          {children}
        </div>
      </div>
    </div>
        <Footer/>
    </>
  )
}

const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    miniMenu: dispatch.general.miniMenu,
  };
};
export default connect(mapStateToProps)(Layout);
